module.exports = __webpack_public_path__ + "static/media/arrow.52b7bd2d.png";